import React from 'react';
import { ErrorView } from '../src/components/Error/ErrorView';

const NotFound = ({ ...pageProps }) => {
	return <ErrorView {...pageProps} />;
};

export default NotFound;
